import benefitsChoiceReducer, {
  benefitsChoiceAdapter,
  benefitsChoiceSlice,
} from './reducer';

const benefitsChoiceActions = {
  ...benefitsChoiceSlice.actions,
};

const benefitsChoiceSelectors = {
  ...benefitsChoiceAdapter.getSelectors(),
};

export { benefitsChoiceActions, benefitsChoiceReducer, benefitsChoiceSelectors };
